import styled from "styled-components";

import { Spinner } from "@8x8/oxygen-loaders";
import { Ghostly } from "@8x8/oxygen-graphics";
import Typography from "@8x8/oxygen-typography";

export const ScrollableContainer = styled.div`
  display: flex;

  // Parent height is defined in Container in
  // src/react/components/customer/modal/styled.jsx
  // Modify that instead of this.
  flex: 1;

  margin: 8px 0 0;

  overflow-x: hidden;
  overflow-y: auto;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SpinnerWrapper = styled.div`
  margin: 0 auto;
  align-self: center;
`;

export const LoadingSpinner = styled(Spinner)`
  margin: 0;
`;

export const NoResultsContainer = styled.div`
  align-self: center;
  margin-left: auto;
  margin-right: auto;
`;

export const StyledGhostly = styled(Ghostly)`
  margin-bottom: 8px;
`;

export const Message = styled(Typography)`
  text-align: center;
`;
